import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { KeyUri, config } from "../key";
import { toast } from "react-toastify";

const initialState = {
  reviews: null,
  loading: false,
  hasError: false,
};

export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.hasError = false;
    },

    requestFailure: (state) => {
      state.loading = false;
      state.hasError = true;
    },

    getReviewsSuccess: (state, { payload }) => {
      state.loading = false;
      state.reviews = payload;
    },

    createReviewSuccess: (state, { payload }) => {
      state.loading = false;
      state.reviews.push(payload); // Add new review to state
    },
  },
});

export const { requestStart, requestFailure, getReviewsSuccess, createReviewSuccess } = reviewSlice.actions;

export const reviewSelector = (state) => state.review;

// ✅ Fetch reviews by ride ID
export const fetchReviews = (rideId) => async (dispatch) => {
  dispatch(requestStart());
  try {
    const { data } = await axios.get(`${KeyUri.BACKEND_URI}/review/${rideId}`, config);
    dispatch(getReviewsSuccess(data.reviews));

  } catch (error) {
    dispatch(requestFailure());
  }
};

// ✅ Create a new review
export const createReview = (reviewData) => async (dispatch) => {
  dispatch(requestStart());
  try {
    const { data } = await axios.post(`${KeyUri.BACKEND_URI}/createReview`, reviewData, config);
   
    toast.success(data?.message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: true,
    });

    dispatch(createReviewSuccess(data.review));
  
  } catch (error) {
    toast.error( {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: true,
    });
    dispatch(requestFailure());
  }
};

export default reviewSlice.reducer;
